// extracted by mini-css-extract-plugin
module.exports = {"autoSubmitWrapper":"autoSubmit__autoSubmitWrapper___vhedw","button":"autoSubmit__button___-Tifd","icon":"autoSubmit__icon___8NKKV","buttonGroup":"autoSubmit__buttonGroup___k2dUc"};